import { Disclosure, Transition } from "@headlessui/react";
import { MenuAlt1Icon, XIcon } from "@heroicons/react/outline";
import React, { useEffect, useState } from "react";

const navigationArr = [
	{ id: 1, name: "About", href: "#about", current: true },
	{ id: 2, name: "Experience", href: "#experiences", current: false },
	{ id: 3, name: "Projects", href: "#projects", current: false },
	{ id: 4, name: "Skills", href: "#skills", current: false },
	{ id: 5, name: "Achievements", href: "#achievements", current: false },
	{ id: 6, name: "Contact Me", href: "#contact", current: false },
];

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

export default function Navbar() {
	const [navigation, setNavigation] = useState(navigationArr);

	useEffect(() => {
		const handleScroll = () => {
			const sectionOffsets = navigation.map((navItem) => ({
				id: navItem.id,
				offset: document.getElementById(navItem.href.slice(1))?.offsetTop,
			}));

			const scrollPosition = window.scrollY + window.innerHeight / 2;

			const currentSection = sectionOffsets.find(
				({ offset }, index, array) =>
					offset <= scrollPosition &&
					(array[index + 1]?.offset
						? array[index + 1].offset > scrollPosition
						: true)
			);

			if (currentSection) {
				setNavigation((prevNavigation) =>
					prevNavigation.map((navItem) => ({
						...navItem,
						current: navItem.id === currentSection.id,
					}))
				);
			}
		};

		// Attach the scroll event listener
		window.addEventListener("scroll", handleScroll);

		// Clean up the event listener on component unmount
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [navigation]);

	const handleClick = (id) => {
		console.log(id);
		let newState = navigation.map((s) => {
			if (s.id === id) return { ...s, current: true };
			return { ...s, current: false };
		});
		console.log(newState);
		setNavigation([...newState]);
	};

	return (
		<Disclosure as='nav' className='bg-gray-800 sticky top-0 z-10'>
			{({ open }) => (
				<React.Fragment>
					<div className='mx-auto px-5 xl:px-40 z-50'>
						<div className='relative flex items-center justify-between h-16'>
							<div className='absolute inset-y-0 left-0 flex items-center sm:hidden'>
								{/* Mobile menu button*/}
								<Disclosure.Button className='inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700'>
									<span className='sr-only'>Open main menu</span>
									{open ? (
										<XIcon
											className='transition-all ease-in-out duration-700 block h-6 w-6'
											aria-hidden='true'
										/>
									) : (
										<MenuAlt1Icon
											className='transition-all ease-in-out duration-700 block h-6 w-6'
											aria-hidden='true'
										/>
									)}
								</Disclosure.Button>
							</div>
							<div className='flex-1 flex items-center justify-center sm:items-stretch sm:justify-start'>
								<div className='flex-shrink-0 flex items-center'>
									<a
										href='!#'
										className='brand_name text-white font-normal text-2xl'
									>
										<span className='text-yellow-500'>Pranav</span> Mene
									</a>
								</div>
								<div className='ml-auto hidden sm:block'>
									<div className='flex space-x-4'>
										{navigation.map((item) => (
											<a
												onClick={() => handleClick(item.id)}
												key={item.id}
												href={item.href}
												className={classNames(
													item.current
														? "bg-gray-900 text-white"
														: "text-gray-300 hover:bg-gray-700 hover:text-white",
													"px-3 py-2 rounded-md text-sm font-medium"
												)}
												aria-current={item.current ? "page" : undefined}
											>
												{item.name}
											</a>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
					<Transition
						show={open}
						enter='transition-gpu duration-300 ease-in-out'
						enterFrom='transform-gpu w-0 opacity-0'
						enterTo='transform-gpu w-full opacity-100'
						leave='transition-gpu duration-300 ease-in'
						leaveFrom='transform-gpu w-full opacity-100'
						leaveTo='transform-gpu w-0 opacity-0'
					>
						<Disclosure.Panel className='sm:hidden' static>
							<div className='px-2 border-t border-gray-700 py-2 space-y-1 divide-y divide-gray-700 absolute bg-gray-800 w-full'>
								{navigation.map((item) => (
									<Disclosure.Button
										onClick={() => handleClick(item.id)}
										key={item.id}
										as='a'
										href={item.href}
										className={classNames(
											item.current ? "" : "text-gray-400",
											"block px-3 py-2 text-sm font-medium transition-opacity"
										)}
										aria-current={item.current ? "page" : undefined}
									>
										{item.name}
									</Disclosure.Button>
								))}
							</div>
						</Disclosure.Panel>
					</Transition>
				</React.Fragment>
			)}
		</Disclosure>
	);
}
